import { FC } from 'react'
import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

type SetYourOwnMarginsCardType = {}

const SetYourOwnMarginsCard: FC<SetYourOwnMarginsCardType> = ({}) => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm pointing right',
        desktop: {
          dimensions: {
            height: 624,
            width: 624,
          },
          src: '/images/new/robot-arm-pointing-right.png',
        },
        mobile: {
          dimensions: {
            height: 547,
            width: 536,
          },
          src: '/images/new/robot-arm-pointing-down.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      overrideAllImageStyles
      imageStyle={{
        objectFit: 'contain',
        maxWidth: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-lg-4 p-5 pb-lg-10 pe-lg-10 pt-lg-26'>
        <h2 className='fw-semibold lh-1 fs-fluid-36-80'>
          Set your own <span className='color-pink2'>margins</span>.
        </h2>
        <span className='mt-8 mt-lg-0 fw-semibold fs-fluid-18-26'>
          With our simple single plan pricing structure, you have the freedom to
          set your own margins, allowing you to determine the ideal price point for
          your clients and market.
        </span>
        <div className='text-right mt-10 mt-lg-13'>
          <a
            className='btn btn-primary w-100 w-lg-auto btn-lg'
            href='#konnect-form'
          >
            Book a Demo
          </a>
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default SetYourOwnMarginsCard
